/**
 * Phase 18.17 Batch 5 — Country flag helper.
 *
 * Maps an ISO-2 country code to a Unicode emoji flag using regional
 * indicator symbols. Falls back to an empty string when the code is
 * unknown or missing, so callers can render an inline icon instead.
 */
export function countryCodeToFlag(code) {
  if (!code) return "";
  const cc = String(code).trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(cc)) return "";
  const A = 0x1f1e6; // regional indicator A
  return String.fromCodePoint(A + cc.charCodeAt(0) - 65) +
         String.fromCodePoint(A + cc.charCodeAt(1) - 65);
}
